import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useEffect } from 'react';
import { HubConnectionBuilder, } from '@microsoft/signalr';
import { Ajax } from '_utils';
import * as Common from '_common';
export const SpaContext = React.createContext({});
SpaContext.displayName = 'SpaContext';
export function SpaContextProvider(props) {
    let connection = null;
    let interval;
    const [state, setState] = React.useState({});
    useEffect(() => {
        refreshCompleteState();
        startConnection();
        return () => {
            endConnection();
        };
    }, []);
    function startConnection() {
        if (!connection) {
            connection = new HubConnectionBuilder()
                .withUrl(Common.debugSettings.apiRoot + '/api/messages')
                .withAutomaticReconnect()
                .build();
            connection.on('StateChanged', (partialValue) => {
                try {
                    setState((prevState) => setContextProperty(prevState, partialValue));
                }
                catch (e) {
                    console.error(e);
                }
            });
            connection.start().catch((err) => console.error(err));
        }
        if (!interval) {
            interval = setInterval(refreshCompleteState, 60 * 1000);
            refreshCompleteState();
        }
    }
    function endConnection() {
        if (connection) {
            connection.stop();
            connection = null;
        }
        if (interval) {
            clearInterval(interval);
            interval = null;
        }
    }
    async function refreshCompleteState() {
        try {
            const spaContext = await Ajax.get('/api/spa');
            const mappedContext = mapProperties(spaContext);
            setState(mappedContext);
        }
        catch (ex) {
            console.error(ex);
        }
    }
    return (_jsx(SpaContext.Provider, { value: state, children: props.children }));
}
export function useSpaContext() {
    const state = React.useContext(SpaContext);
    return state;
}
export function setContextProperty(current, newValues) {
    try {
        const result = { ...current };
        // recursively merge the new values into the current context
        for (const key in newValues) {
            const normKey = normalizeKey(key);
            if (typeof newValues[key] === 'object') {
                if (!current[normKey]) {
                    current[normKey] = {};
                }
                result[normKey] = setContextProperty(current[normKey], newValues[key]);
            }
            else {
                if (current[normKey] !== newValues[key]) {
                    result[normKey] = newValues[key];
                }
            }
        }
        return result;
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
function normalizeKey(key) {
    if (!key || key.length === 0) {
        return '_';
    }
    if (key.length <= 3) {
        return key.toLowerCase();
    }
    // make first letter lowercase
    return key[0].toLowerCase() + key.substring(1);
}
function adjustPath(path) {
    if (!path || path.length === 0) {
        return '';
    }
    let adjustedPath = path[0].toLowerCase() + path.substring(1);
    if (adjustedPath.length <= 3) {
        adjustedPath = adjustedPath.toLowerCase();
    }
    return adjustedPath;
}
function mapProperties(object) {
    const result = {};
    for (const key in object) {
        let item = object[key];
        if (typeof item === 'object') {
            item = mapProperties(item);
        }
        result[adjustPath(key)] = item;
    }
    return result;
}
